module.exports = __webpack_public_path__ + "media/3_6-9.ee79bf0c.mp3";